import AlgorithmsView from './AlgorithmsView';

export default AlgorithmsView;